import type { Feature } from "./types";

import { getEnvValue } from "../utils";

const title = "User operations";

const config: Feature<{ isEnabled: true }> = (() => {
  if (getEnvValue("NEXT_PUBLIC_HAS_USER_OPS") === "true") {
    return Object.freeze({
      title,
      isEnabled: true,
    });
  }

  return Object.freeze({
    title,
    isEnabled: false,
  });
})();

export default config;
